var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReleaseNotesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 21.625V41.1C41 42.373 40.4942 43.5939 39.5941 44.4941C38.6939 45.3943 37.473 45.9 36.2 45.9H13.8C12.527 45.9 11.3061 45.3943 10.4059 44.4941C9.50571 43.5939 9 42.373 9 41.1V9.10004C9 7.827 9.50571 6.60611 10.4059 5.70593C11.3061 4.80576 12.527 4.30005 13.8 4.30005H23.675C24.5234 4.30018 25.337 4.63721 25.937 5.23705L40.063 19.363C40.6628 19.963 40.9998 20.7766 41 21.625Z",
    stroke: "#445879",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5.10004V17.1C25 17.9487 25.3371 18.7626 25.9372 19.3628C26.5374 19.9629 27.3513 20.3 28.2 20.3H40.2M17 28.3H33M17 36.3H33",
    stroke: "#445879",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseNotesIcon);
export default __webpack_public_path__ + "static/media/release_notes_icon.d496d878.svg";
export { ForwardRef as ReactComponent };